import {GetStaticPathsContext} from 'next';

import {disallowSlug} from '@udemy/nextjs-core';

import {FreeCategoryPage} from 'src/features/category/free-category-page';

import {FREE_CATEGORY_CONFIG, getFreeCategoryStaticProps} from '../lib/get-free-category-data';

export async function getStaticPaths({}: GetStaticPathsContext) {
    return {
        paths: [],
        fallback: 'blocking',
    };
}
export const getStaticProps = disallowSlug(async (context) => {
    return getFreeCategoryStaticProps(FREE_CATEGORY_CONFIG.free.title_cleaned, context);
});

export default FreeCategoryPage;
